<script setup>
import { ref, onMounted } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'

const searchInfo = ref({
  keyword: '',
  company_type: ''
})

const identityList = [
  { value: 'Jsw', label: '榮星' },
  { value: 'Supplier', label: '供應商' },
  { value: 'Customer', label: '客戶' }
]

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.keyword = searchParams.get('keyword')
  searchInfo.value.company_type = searchParams.get('company_type')
})
</script>

<template>
  <form class="min-w-[248px] p-4" action="/settings/users" accept-charset="UTF-8" method="get">
    <div class="mb-2">
      <BaseTextInput
        :label="'帳號／名稱'"
        :name="'keyword'"
        v-model="searchInfo.keyword"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'身份'"
        :name="'company_type'"
        :optionList="identityList"
        :optionsSelected="searchInfo.company_type"
        @select="searchInfo.company_type = $event"
      />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a href="/settings/users?company_type=Jsw" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
